<div class="home-portal">
    <div class="overview">
        <div class="overview-title flex justify-between mx:mb-6 sm:mb-4">
            <div class="flex items-center">
                <span class="mx:w-2 mx:h-5 sm:w-1.5 sm:h-4  bg-[#007BC0] mr-2"></span>
                <span class="sm:text-base mx:text-xl font-bold">{{ yearString }} {{ "JAN" | translate }} - {{ yearString }} {{ monthString }} {{ "OVERVIEW" | translate }}</span>
            </div>
        </div>
        <div class="overview__chart flex justify-between flex-wrap text-[#7D8389]">
            <div class="overview__chart-item border-[#007BC0] mx:py-4 sm:py-1 mx:w-[calc(25%-12px)] sm:w-[calc(50%-4px)] sm:mb-2">
                <div class="text-xl">{{ "YTD_TURNOVER" | translate }}</div>
                <div class="text-[#1F1F1F]">
                    <span class="text-[#1F1F1F] font-bold pr-2 mx:text-3xl sm:text-xl sm:block">{{ formatNumber(actualTurnover)}} </span>
                    <span class="text-xl sm:block">{{ currencyName }}</span>
                </div>
            </div>
            <div class="overview__chart-item border-[#ED0007] mx:py-4 sm:py-1 mx:w-[calc(25%-12px)] sm:w-[calc(50%-4px)] sm:mb-2 cursor-pointer" (click)="goOrder('creditBlock')">
                <div class="text-xl">{{ "CREDIT_BLOCK" | translate }}</div>
                <div class="text-[#1F1F1F] ">
                    <span class="font-bold pr-2 mx:text-3xl sm:text-xl sm:block">{{ formatNumber(creditBlock)}}</span>
                    <span class="text-xl sm:block">{{ currencyName }}</span>
                </div>
            </div>
            <div class="overview__chart-item border-[#18837E] mx:py-4 sm:py-1 mx:w-[calc(25%-12px)] sm:w-[calc(50%-4px)] sm:mb-2 cursor-pointer" (click)="goOrder('warehouse')">
                <div class="text-xl">{{ "IN_WAREHOUSE_PROCESS" | translate }}</div>
                <div class="text-[#1F1F1F] ">
                    <span class="text-[#1F1F1F] font-bold pr-2 mx:text-3xl sm:text-xl sm:block">{{ formatNumber(inWarehouseProcessing)}} </span>
                    <span class="text-xl sm:block">{{ currencyName }}</span>
                </div>
            </div>
            <div class="overview__chart-item border-[#9E2896] mx:py-4 sm:py-1 mx:w-[calc(25%-12px)] sm:w-[calc(50%-4px)] sm:mb-2 cursor-pointer" (click)="goOrder('open')">
                <div class="text-xl">{{ "OPEN" | translate }}</div>
                <div class="text-[#1F1F1F] ">
                    <span class="text-[#1F1F1F] font-bold pr-2 mx:text-3xl sm:text-xl sm:block">{{ formatNumber(opened)}} </span>
                    <span class="text-xl sm:block">{{ currencyName }}</span>
                </div>
            </div>
        </div>
    </div>
    
    <div class="border-t border-[#DBDBDB] mx:my-6 sm:my-4"></div>
    
    <div class="statistic">
        <div class="overview-title mb-6 flex justify-between">
            <div class="flex items-center">
                <span class="mx:w-2 mx:h-5 sm:w-1.5 sm:h-4  bg-[#007BC0] mr-2"></span>
                <span class="sm:text-base mx:text-xl font-bold">{{ "ACHIEVEMENT_BY_MONTH" | translate }}</span>
            </div>
            <nz-select 
                nzBorderless
                [(ngModel)]="currentCbfType"
                [nzOptionOverflowSize]="6"  
                [nzDropdownMatchSelectWidth]="false"
                [nzPlaceHolder]="'CBF' | translate "
                (ngModelChange)="handleChangeProductType($event)" >
                <nz-option
                    nzCustomContent 
                    [nzLabel]="getCbfDescription(data)"
                    [nzValue]="getCbfDescription(data)"
                    *ngFor="let data of cbfTypeOption">
                    <div>{{ getCbfDescription(data) }}</div>
                </nz-option>
            </nz-select>
        </div>
        <div class="statistic__chart-content">
            <div class="statistic__chart-box">
                <div id="achievementChart" class="statistic__chart" style="width: 100%; height: 200px;"></div>
            </div>
        </div>
    </div>

    <div class="border-t border-[#DBDBDB] mx:my-6 sm:my-4"></div>

    <div class="mx:visible sm:hidden">
        <div class="overview-title mb-6 flex justify-between ">
            <div class="flex items-center">
                <span class="mx:w-2 mx:h-5 sm:w-1.5 sm:h-4  bg-[#007BC0] mr-2"></span>
                <span class="sm:text-base mx:text-xl font-bold">{{ "YTD_ACHIEVEMENT_BY_CBF" | translate }}</span>
            </div>
        </div>
        <nz-table 
            #headerTable
            class="e-shop-table" 
            [nzShowPagination]="false"
            [nzData]="achievementDetailCardData"
             [nzScroll]="{ y: '280px'}">
            <thead>
                <tr>
                    <th>{{ "CBF" | translate }}</th>
                    <th [nzWidth]="'20%'">{{ "YTD_ACTUAL_TURNOVER" | translate }}</th>
                    <th [nzWidth]="'20%'">{{ "YTD_LAST_YEAR" | translate }}</th>
                    <th>{{ "PERCENTAGE" | translate }}</th>
                    <th>{{ "IN_WAREHOUSE_PROCESS" | translate }}</th>
                    <th>{{ "OPEN" | translate }}</th>
                    <th>{{ "CREDIT_BLOCK" | translate }}</th>
                </tr>
            </thead>
            <tbody class="order">
                <tr *ngFor="let item of achievementDetailCardData">
                    <td>{{ getCbfDescription(item.cbf) }}</td>
                    <td>{{ formatNumber(item.actualTurnover || 0) }}</td>
                    <td>{{ formatNumber(item.lastYearYtdTurnover || 0) }}</td>
                    <td>{{ formatPercentage(item.percentage) }}</td>
                    <td>{{ formatNumber(item.inWarehouseProcessing || 0) }}</td>
                    <td>{{ formatNumber(item.opened || 0) }}</td>
                    <td>{{ formatNumber(item.creditBlock || 0) }}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>

    <div class="mx:hidden sm:visible">
        <div class="overview-title mb-4">
            <div class="flex items-center">
                <span class="mx:w-2 mx:h-5 sm:w-1.5 sm:h-4  bg-[#007BC0] mr-2"></span>
                <span class="sm:text-base mx:text-xl font-bold">{{ "YTD_ACHIEVEMENT_BY_CBF" | translate }}</span>
            </div>
        </div>
        <div class="cbf-list">
            <div *ngFor="let item of achievementDetailCardData" class="mb-3 border-solid border border-[#EFF1F2] text-xs text-black">
                <div class="p-2 bg-[#EFF1F2] font-bold">{{ getCbfDescription(item.cbf) }}</div>
                <div class="p-2">
                    <div class="flex justify-between mb-1">
                        <span>{{ "YTD_ACTUAL_TURNOVER" | translate }}</span>
                        <span class="text-[#595E62]">{{ formatNumber(item.actualTurnover || 0) }}</span>
                    </div>
                    <div class="flex justify-between mb-1">
                        <span>{{ "YTD_LAST_YEAR" | translate }}</span>
                        <span class="text-[#595E62]">{{ formatNumber(item.lastYearYtdTurnover || 0) }}</span>
                    </div>
                    <div class="flex justify-between mb-1">
                        <span>{{ "PERCENTAGE" | translate }}</span>
                        <span class="text-[#595E62]">{{ formatPercentage(item.percentage) }}</span>
                    </div>
                    <div class="border-t border-[#DBDBDB] my-2"></div>
                    <div class="flex justify-between mb-1">
                        <span>{{ "IN_WAREHOUSE_PROCESS" | translate }}</span>
                        <span class="text-[#595E62]">{{ formatNumber(item.inWarehouseProcessing || 0) }}</span>
                    </div>
                    <div class="flex justify-between mb-1">
                        <span>{{ "OPEN" | translate }}</span>
                        <span class="text-[#595E62]">{{ formatNumber(item.opened || 0) }}</span>
                    </div>
                    <div class="flex justify-between mb-1">
                        <span>{{ "CREDIT_BLOCK" | translate }}</span>
                        <span class="text-[#595E62]">{{ formatNumber(item.creditBlock || 0) }}</span>
                    </div>
                </div>
            </div>

            <nz-empty nzNotFoundImage="simple" *ngIf="achievementDetailCardData?.length === 0"></nz-empty> 
        </div>
    </div>
</div>